import SuggestMapClick from "~/route/item/suggest-mapclick";
import { Scene, _ } from "~/route/globals";
import { node, icon } from "~/util/dom";
import Items, { IItemData } from "~/route/items";
import FixedSuggest from "~/route/item/suggest-fixed";
import { ROUTE_CONST } from "~/route/const";
import { getPosition } from "~/route/utils";

function getImage() {
	const image = node("div", { className: "image dad-handle" });

	image.appendChild(icon("pin"));

	return image;
}

function getTitle(position) {
	return position === ROUTE_CONST.position.start ? _("route.setStart") : position === ROUTE_CONST.position.end ? _("route.setEnd") : _("route.setPoint");
}

/**
 * Obal pro:
 * - prazdny item
 */
export default class ItemEmpty {
	_parent: Items;

	_data: Partial<IItemData>;

	_focusInterval: NodeJS.Timer;

	_dom: {
		container: HTMLDivElement;
		inner?: HTMLDivElement;
		position?: HTMLParagraphElement;
		dadHandler?: HTMLDivElement;
		emptyCont?: HTMLDivElement;
		button?: HTMLButtonElement;
	};

	_fixedSuggest: FixedSuggest;

	_suggestMapClick: SuggestMapClick;

	_state: IItemData;

	constructor(parent: Items, data: Partial<IItemData>) {
		this._parent = parent;
		this._data = data;
		this._focusInterval = null;
		this._dom = {
			container: node("div", { className: "route-item-empty" }),
		};
		this._fixedSuggest = null;
		this._suggestMapClick = new SuggestMapClick(this._dom.container, suggestData => {
			this._suggestMapClickCb(suggestData);
		});
		this._state = null;

		this._build();
	}

	destroy() {
		this._suggestMapClick.destroy();
		if (this._fixedSuggest) {
			this._fixedSuggest.destroy();
		}
		this._dom.container.remove();
	}

	get container() {
		return this._dom.container;
	}

	get state() {
		return this._state;
	}

	focus() {
		if (this._suggestMapClick.input.isConnected) {
			if (this._focusInterval) {
				clearInterval(this._focusInterval);
				this._focusInterval = null;
			}
			this._suggestMapClick.input.focus();
		} else {
			this._focusInterval = setInterval(() => {
				if (this._suggestMapClick.input.isConnected) {
					if (this._focusInterval) {
						clearInterval(this._focusInterval);
						this._focusInterval = null;
					}
					this._suggestMapClick.input.focus();
				}
			}, 100);
		}
	}

	/**
	 * Nastaveni nove pozice - pri editaci.
	 *
	 * @param   {Number}  position Enum pozice
	 * @param   {Number}  ind  Poradi
	 */
	setPosition(position, ind) {
		this._dom.position.textContent = getPosition(position, ind);
		this._suggestMapClick.input.placeholder = getTitle(position);
	}

	_build() {
		// vnitrni cast
		this._dom.inner = node("div", { className: "inner" });
		this._dom.dadHandler = node("div", { className: "dad dad-handle dad-handle-touch" });
		const iconMove = icon("move");

		this._dom.dadHandler.appendChild(iconMove);
		const cont = node("div", { className: "cont" });

		// oblasti navic do marginu, aby se dalo tahat pri dad
		const dadAreaLeft = node("div", { className: "dad-area dad-handle left" });
		const dadAreaRight = node("div", { className: "dad-area dad-handle right" });

		this._dom.position = node("p", { className: "dad-handle", textContent: getPosition(this._data.position, this._data.ind) });
		this._suggestMapClick.contElem = cont;
		this._suggestMapClick.input.placeholder = getTitle(this._data.position);
		const desc = node("p", { className: "subtitle dad-handle" });

		// focus pri kliknuti
		this._dom.inner.addEventListener("click", () => {
			this.focus();
		});

		cont.appendChild(this._dom.position);
		cont.appendChild(this._suggestMapClick.input);
		cont.appendChild(desc);
		this._dom.inner.appendChild(this._dom.dadHandler);
		this._dom.inner.appendChild(getImage());
		this._dom.inner.appendChild(cont);
		this._dom.inner.appendChild(dadAreaLeft);
		this._dom.inner.appendChild(dadAreaRight);
		this._dom.container.appendChild(this._dom.inner);
		// fixni suggest
		this._fixedSuggest = new FixedSuggest(cont, this._suggestMapClick);
	}

	_suggestMapClickCb(data) {
		this._state = {
			position: this._data.position,
			favoriteId: "",
			usertitle: "",
			typeId: 0,
			...data,
		};
		//this._parent.updateState({}, this); - zrusime this - nechceme scrolovat na novy item
		this._parent.updateState({ zoom: data.from !== "mapClick" });

		// pokud je ze suggestu, tak po zaroutovani se pokusime ulozit do uzivatelske historie
		if (data.from === "suggest" || data.from === "history") {
			let lon = 0;
			let lat = 0;

			if (data.geometry) {
				const coords = Scene.stringToCoords(data.geometry);

				if (coords && coords.length) {
					lat = coords[0].y;
					lon = coords[0].x;
				}
			}

			const toHistory = Mapy.CML.state.route.toHistory;

			if (data.source === "coor") {
				toHistory.push({
					title: data.title,
					source: "web",
					type: "query",
				});
			} else {
				toHistory.push({
					title: data.title,
					source: "web",
					type: "poi",
					data: {
						entityId: data.id,
						entitySource: data.source,
						lon: lon,
						lat: lat,
					},
				});
			}

			Mapy.CML.state = {
				route: {
					toHistory,
				},
			};
		}

		Mapy.getComponent("history").save();
	}
}
